export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9734.71c6a5f3.jpg";